import { SelectOption } from '../components/Select'

export const treeOptions = <T>(
    data: T[],
    element: T | null,
    label: keyof T,
    value: keyof T,
    parent_id: keyof T,
    id: keyof T,
    level: number
) => {
    const options: SelectOption[] = []

    if (element) {
        options.push({ label: element[label] + '', value: element[value] + '' })
    }

    const children = element
        ? data.filter((e) => e[parent_id] === element[id])
        : data.filter((e) => !e[parent_id])

    children
        .sort((a, b) => {
            if (a[label] < b[label]) return -1
            if (a[label] > b[label]) return 1
            return 0
        })
        .forEach((child) => {
            options.push(
                ...treeOptions(
                    data,
                    child,
                    label,
                    value,
                    parent_id,
                    id,
                    level + 1
                )
            )
        })

    return options.map((option) => {
        option.label = `${'\xa0'.repeat(level)}${option.label}`
        return option
    })
}
